import { Layout } from './layout.model';

export enum PanelName {
  MAIN_PANEL = 'main-panel',
  HELP_PANEL = 'help-panel'
}

export const LayoutConfig: Layout = {
  panel: [{ panel: PanelName.MAIN_PANEL }, { panel: PanelName.HELP_PANEL }],
  panelSizes: [70, 30],
  minSizes: [69.999, 0.001]
};

export enum GeneralHelpConst {
  RefScroll = 'refScroll'
}
